<template>
  <div class="meou_box">
    <div class="box" v-for="item in info">
        <div class="list" v-for="val in item">
            <span>{{val.text}}</span>
            <p>{{val.value}}</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    info:Array
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="less">
.meou_box {
   font-family: number-bold;
    padding: 0 12px;
    background-color: #fff;
    .box {
      display: flex;
        width: 351px;
        height: 58px;
        .list {
          flex:1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
          span {
              font-size: 12px;
              color:#8E9AAE;
            }
            p {
              font-weight: 500;
              font-size: 16px;
              color:#141B27;
            }
        }
    }
}
</style>
